import React from "react";
import { Image, StyleSheet } from "react-native";

import { spacing } from "@stepapp/ui";

const [warsawLongitude, warsawLatitude] = [21.01178, 52.22977];

type Props = {
  longitude?: Maybe<number>;
  latitude?: Maybe<number>;
};

const baseUrl = "https://api.mapbox.com/styles/v1/stepapp/ckc28rwvf6pf71io1zyc1p3wr/static";

const MapView = ({ longitude = warsawLongitude, latitude = warsawLatitude }: Props) => {
  const pin = `pin-l-marker+000054(${longitude},${latitude})`;
  const size = `${spacing.deviceWidth}x${spacing.deviceHeight * 0.5}@2x`;
  const accessToken = `access_token=${process.env.NEXT_PUBLIC_MAPBOX_API_KEY}`;
  const mapParams = `${longitude},${latitude},16`;

  return (
    <Image
      source={{ uri: `${baseUrl}/${pin}/${mapParams}/${size}?${accessToken}` }}
      style={styles.map}
    />
  );
};

export default React.memo(MapView);

const styles = StyleSheet.create({
  map: {
    flex: 1,
  },
});
